import React from 'react';
import PropTypes from 'prop-types';

import {Badge as BaseBadge} from '@spothero/ui';

const badgeStyleProps = {
    borderRadius: 'full',
    paddingX: 2,
    paddingY: '1px',
    fontWeight: 'semibold',
};

const Badge = ({variant = 'primary', ...rest}) => {
    return <BaseBadge variant={variant} {...badgeStyleProps} {...rest} />;
};

Badge.propTypes = {
    /** Additional class(es) to add to the component. */
    variant: PropTypes.string,
    /** The node (typically a string) to put in the badge. */
    children: PropTypes.node.isRequired,
};

export default Badge;
